import qs from 'query-string';

import { fetchError, getCookieToken } from './index';

function parseJSON(response: any) {
  return response.json();
}

function checkStatus(response: any) {
  // 常规状态
  if (response.status >= 200 && response.status < 300) {
    return response;
  }
  // 特殊状态
  const statusArr = [400];
  if (statusArr.includes(response.status)) {
    return response;
  }

  const error = new Error(response);
  error.response = response;
  throw error;
}

/**
 * Requests a URL, returning a promise.
 *
 * @param  {string} url       The URL we want to request
 * @param  {object} [options] The options we want to pass to "fetch"
 * @return {object}           An object containing either "data" or "err"
 */

export function requestForm(url: string, options: any, contentType?: any) {
  const Authorization = getCookieToken();

  let headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
  };
  if (contentType) {
    headers['Content-Type'] = contentType;
  }

  if (Authorization) {
    headers['Authorization'] = `${Authorization}`;
  }

  let newUrl = url;
  let { payload, method } = options;
  if (method.toUpperCase() == 'GET' && payload) {
    // get 请求
    newUrl += '?' + qs.stringify(payload);
  } else {
    options.body = qs.stringify(payload); // post 请求
  }

  // json 格式
  if (contentType && payload) {
    options.body = JSON.stringify(payload);
  }

  let aUrl = newUrl;
  //  请求超时处理
  let fetchPromise = fetch(aUrl, {
    headers: headers,
    ...options,
  });
  return fetch_timeout(fetchPromise, 40000);
}

/**
 * 实现fetch的timeout 功能
 * @param {object} fecthPromise fecth
 * @param {Number} timeout 超时设置，默认5000ms
 * */

function fetch_timeout(fetchPromise: any, timeout = 1000 * 30) {
  let abort = null;
  let fetchTimeout: string | number | NodeJS.Timeout | null | undefined = null; // 超时定时器
  let abortPromise = new Promise((resolve, reject) => {
    abort = () => {
      return reject({
        code: 504,
        message: '请求超时',
      });
    };
  });

  // 最快出结果的promise 作为结果
  let resultPromise = Promise.race([fetchPromise, abortPromise]);
  fetchTimeout = setTimeout(() => {
    abort();
  }, timeout); // 超时执行

  return resultPromise
    .then(checkStatus)
    .then(parseJSON)
    .then((data: any) => {
      clearTimeout(fetchTimeout); // 清空定时器
      const { code, msg } = data;
      fetchError(code, msg);
      return data;
    })
    .catch((err: any) => {
      return { err };
    });
}
